export enum ParameterType {
	ConnectionString = 1,
	String = 2,
	Integer = 3,
	Password = 4,
	Email = 5,
}
